export default __webpack_public_path__ + "static/media/avatar_tapir4.f77aee88.mp3";